
import axios from 'axios';

const TIMEOUT = 500000

const api = axios.create({
    baseURL: import.meta.env.VITE_API_ENDPOINT as string,
    timeout: TIMEOUT
});

export default api